import { StatusFailed, StatusInfo, StatusProcessing, StatusSuccess } from '@illustrations';
import classNames from 'classnames';
import React from 'react';
import { statusBoxClasses, StatusBoxSC } from './status-box.styled';
import { TStatusBox } from './status-box.types';

const ICON_MAP: Record<TStatusBox, React.ReactNode> = {
  info: <StatusInfo />,
  success: <StatusSuccess />,
  failed: <StatusFailed />,
  processing: <StatusProcessing />,
} as const;

type StatusBoxProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  type?: TStatusBox;
  className?: string;
};

const StatusBox: React.FC<StatusBoxProps> = ({
  title,
  description,
  type = 'success',
  className,
}) => {
  return (
    <StatusBoxSC className={classNames(className, statusBoxClasses.wrapper)}>
      <div className={statusBoxClasses.icon}>{ICON_MAP[type]}</div>
      <div className={statusBoxClasses.title}>{title}</div>
      {description && <div className={statusBoxClasses.description}>{description}</div>}
    </StatusBoxSC>
  );
};

export default StatusBox;
